import { useQuery } from "@apollo/client/react";
import { adaptEquipoArray, GET_EQUIPO_BY_ID_EVALUACION } from "../../../../../data/graphQL/queries/ResumenIngresoValidation/getConfirmacionEquipoByIdEvaluacion";

export function useTabProfesionalViewEquipoRows({
  idEvaluacion
}) {

  const { data, loading } = useQuery(GET_EQUIPO_BY_ID_EVALUACION, {
    variables: {
      idEvaluacion: idEvaluacion
    }
  });

  const rows = adaptEquipoArray(data) || [];
  const totalCount = rows.length || 0;

  return {
    rows,
    totalCount,
    loading
  };
}